import {
  createTenantIdInterceptorSetAction,
  TENANT_ID_INTERCEPTOR_SET,
} from "./../actions/tenantId";
import { ITenantIdPayload } from "../actions/tenantId";

export interface ITenantState extends ITenantIdPayload {}

export const initialTenantState: ITenantState = {};

export const tenantReducer = (
  previousState: ITenantState = initialTenantState,
  action: ReturnType<typeof createTenantIdInterceptorSetAction>
) => {
  switch (action.type) {
    case TENANT_ID_INTERCEPTOR_SET:
      return {
        ...previousState,
        tenantId: action.payload.tenantId,
        interceptorId: action.payload.interceptorId,
      };
  }

  return previousState;
};
